import classNames from "classnames"
import { format, parseISO } from "date-fns"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { Dialog } from "primereact/dialog"
import React, { useEffect, useState } from "react"
import { Api } from "../../../../services/api"
import { formatCurrency } from "../../../../utils/formatCurrency"


function CobrancaQuebrada({ close, cobranca_quebrada_id }) {
  const [cobrancaQuebradaGeral, setCobrancaQuebradaGeral] = useState(null)
  const [cobrancaQuebradaDetalhes, setCobrancaQuebradaDetalhes] = useState([])
  const [cobrancaQuebradaBoletos, setCobrancaQuebradaBoletos] = useState([])
  const [loading,setLoading] = useState(false)

  function bodyStatusBoletos(rowData){
    if(rowData.boleto_status === 'true')
    return (
      <span className="customer-badge status-qualified">
      Pago
      </span>
    ) 
    else
    return (
      <span className="customer-badge status-unqualified">
      Não Pago
      </span>
    ) 
  }

  useEffect(() => {
    async function fetchQuebradas() {
      try {
        setLoading(true)
        const { data } = await Api.get(`cobranca/quebrada/${cobranca_quebrada_id}`)
        const quebradasDetalhe = data

        const contemTotais = quebradasDetalhe[0]
        const nContemTotais = quebradasDetalhe.slice(1)
        const checkBoletos = quebradasDetalhe.length > 0 ? quebradasDetalhe[0].boletos : []


        //console.log('Geral', contemTotais)
        //console.log('Descrição', nContemTotais)
        //console.log('Boletos', checkBoletos)
        //console.log(quebradasDetalhe);
        setCobrancaQuebradaGeral(contemTotais)
        setCobrancaQuebradaDetalhes(nContemTotais)
        setCobrancaQuebradaBoletos(checkBoletos)
      } catch (error) {
        console.log(error.response)
      } finally{
        setLoading(false)
      }
    }

    fetchQuebradas()
  }, [])


  return (
    <Dialog
      visible
      className='text-center'
      header="Detalhes da cobrança passada"
      onHide={() => close()}
      pt={{
        root: 'w-screen md:w-[40vw] max-h-[80vh] ',
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80'),
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]', 
            'bg-white text-gray-700 px-6 pb-8 pt-0', 
            'rounded-bl-lg rounded-br-lg', 
            'dark:bg-gray-900 dark:text-white/80 ', {
              grow: state.maximized
          })
        }),
      }}
    >
      <div>
        <div>
          <h5 className="font-bold text-xl mb-3">Negociação</h5>
          {cobrancaQuebradaGeral &&
            <div className="text-lg">
              <h6>Data Negociação: <b>{format(new Date(cobrancaQuebradaGeral.v_cobranca_create),'dd/MM/yyyy hh:mm')}</b> </h6>
              <h6>Valor Negociação: <b>{formatCurrency(cobrancaQuebradaGeral.v_negociacao_quebrada_valor_divida)}</b> </h6>
              <h6>Valor Pago: <b>{formatCurrency(cobrancaQuebradaGeral.v_negociacao_quebrada_valor_pago)}</b> </h6>
              <h6>Valor Restante: <b>{formatCurrency(cobrancaQuebradaGeral.v_negociacao_quebrada_valor_saldo)}</b> </h6>
            </div>
          }
        </div>
        <div>
          <h5 className="font-bold text-xl mb-3 mt-3">Cobranças Negociadas</h5>
          <DataTable emptyMessage='Nenhuma informação sobre a negociação quebrada.' value={cobrancaQuebradaDetalhes} loading={loading}>
            <Column header="Descrição" field="v_cobranca_descricao" />
            <Column header="Valor" field="v_cobranca_valor" body={(rowCurrent)=>{return formatCurrency(rowCurrent.v_cobranca_valor)}} />
            <Column header="Vencimento" field="v_data_vencimento_primeiro_boleto" body={(rowCurrent)=>{return format(parseISO(rowCurrent.v_data_vencimento_primeiro_boleto),'dd/MM/yyyy')}} />
          </DataTable>
        </div>
        <div>
          <h5 className="font-bold">Boletos</h5>
          <DataTable emptyMessage='Nenhuma informação sobre a negociação quebrada.' value={cobrancaQuebradaBoletos} loading={loading}>
            <Column header="Valor" field="boleto_valor" body={(rowCurrent)=>{return formatCurrency(rowCurrent.boleto_valor)}} />
            <Column header="Boleto Status" field="boleto_status" body={(rowCurrent)=>bodyStatusBoletos(rowCurrent)} />
            <Column header="Vencimento" field="cobranca_data_vencimento" body={(rowCurrent)=>{return format(parseISO(rowCurrent.cobranca_data_vencimento),'dd/MM/yyyy')}} />
          </DataTable>
        </div>
      </div>
    </Dialog>
  )
}

export default CobrancaQuebrada